import { headerBarSearch, categorySearch } from "../api/actions/SearchActions";
import store from "../redux/Store";
import {
    HEADER_SEARCH_BAR_DONE,
    CATEGORY_SEARCH_RESULTS,
    COLLECTION_FILTER,
    UPDATE_VARIANTS,
    UPDATE_FILTER,
    UPDATE_BRANDS
} from "./actions/SearchActions";

const doSearch = (term) => {
    store.dispatch(HEADER_SEARCH_BAR_DONE('loading'));
    headerBarSearch(term).then(response => {
        //console.log('search.evemts.doSearch', response.content);
        store.dispatch(HEADER_SEARCH_BAR_DONE('done', response.content));
    }).catch(error => {
        store.dispatch(HEADER_SEARCH_BAR_DONE('error', error));
    });
};

let doSearchDebounced = doSearch.debounce(500, false);

export const dispatch_headerSearch_Event = (e) => {
    if (e?.target) {
        doSearchDebounced(e.target.value)
    }
};
export const dispatch_ClearHeaderSearch_Event = (e) => {
    store.dispatch(HEADER_SEARCH_BAR_DONE('', null));
};

const doCategorySearch = (term) => {

    store.dispatch(UPDATE_VARIANTS('loading', []));
    store.dispatch(UPDATE_FILTER('loading'));
    store.dispatch(UPDATE_BRANDS('loading'));

    categorySearch(term).then(response => {
        //console.log('doCategorySearch', response.content);
        let variants = response?.content?.variants || [];
        let filter = response?.content?.filter || [];
        let brands = response?.content?.brands || [];

        variants.forEach(variant => {
            if (variant.variantDetailsJson) {
                variant.variantDetailsJson = JSON.parse(variant.variantDetailsJson);
                variant.variantDetailsJson['brands'] = variant.brand;
            }else{
                variant['variantDetailsJson'] = {};
                variant.variantDetailsJson['brands'] = variant.brand;
            }
        });

        store.dispatch(UPDATE_VARIANTS('done', variants));
        store.dispatch(UPDATE_FILTER('done', filter));
        store.dispatch(UPDATE_BRANDS('done', brands));

    }).catch(error => {
        store.dispatch(UPDATE_VARIANTS('', []));
        store.dispatch(UPDATE_FILTER('', []));
        store.dispatch(UPDATE_BRANDS('', []));
    });
};

let doCategorySearchDebounced = doCategorySearch.debounce(500, false);

export const dispatch_categorySearch_Event = (term) => {
    doCategorySearchDebounced(term);
};

function countMatches(product, filterState) {
    let matches = 0;
    const variantDetails = product.variantDetailsJson;

    if (variantDetails) {
        for (const [key, values] of Object.entries(filterState)) {
            //console.log('countMatches',key.toLowerCase(), values, variantDetails);
            if (
                variantDetails[key.toLowerCase()] &&
                values.includes(variantDetails[key].toLowerCase())
            ) {
                matches++;
            }
        }
    }
    return matches;
}

export const dispatch_setFilter_Event = (name, target) => {
    //console.log('dispatch_setFilter_Event', name, target.value, target.checked);

    store.dispatch(UPDATE_VARIANTS('loading'));

    let filter = store.getState().common.collectionFilter;
    let category = (Array.isArray(filter[name]) && (filter[name].length > 0)) ? [...filter[name]] : [];
    let found = category.indexOf(target.value);

    (found > -1) ?
        (target.checked == false && category.splice(found, 1)) :
        category.push(target.value);


    store.dispatch(COLLECTION_FILTER({ ...filter, [name]: category }));
};

export const dispatch_applyFilter_Event = () => {

    let variants = store.getState().common.variants.data;
    let filter = store.getState().common.collectionFilter;

    let sorted = [...variants]
        .map(product => ({
            ...product,
            matchCount: countMatches(product, filter)
        }))
        .sort((a, b) => b.matchCount - a.matchCount);

    //console.log('dispatch_applyFilter_Event', variants, sorted);

    store.dispatch(UPDATE_VARIANTS('done', sorted));
    //console.log('dispatch_applyFilter_Event', filter);
};